import { useState, useEffect, useRef } from "react";

/**
 * Google Maps hook.
 *
 * @param google - Google Maps API instance, utilize useGoogleMapsApi() hook to get it.
 * @param mapOptions - Google Maps API options
 */
export function useGoogleMaps(google, mapOptions) {
  const ref = useRef(null);
  const [map, setMap] = useState();

  useEffect(() => {
    if (!google || !ref) {
      return;
    }
    setMap(new google.maps.Map(ref.current, mapOptions));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [google, ref]);

  return {
    ref,
    map,
  };
}
